import { render, staticRenderFns } from "./PayoutDistribution.vue?vue&type=template&id=2f5d4ba8"
import script from "./PayoutDistribution.vue?vue&type=script&lang=js"
export * from "./PayoutDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports